module.exports = __webpack_public_path__ + "img/814.f4511972.svg";